import React from 'react';
import { Link } from 'react-router-dom';
import { LuMoon, LuSun } from 'react-icons/lu';
import UserMenu from './UserMenu.js';
import GlobeMark from './ui/GlobeMark.jsx';
import IconButton from './ui/IconButton.jsx';
import { useDarkMode } from '../hooks/useDarkMode.js';

const isEmbedded = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

function Topbar({ currentUser, logout }) {
  const [darkMode, toggleDarkMode] = useDarkMode();

  // Embedded in another app (iframe): that app owns the header and the session.
  if (isEmbedded()) return null;

  return (
    <header className="relative z-30 flex-none border-b border-gray-200 bg-white shadow-sm dark:border-gray-900 dark:bg-night-900 dark:shadow-md">
      <div className="flex h-14 items-center justify-between gap-4 px-4 sm:px-6">
        <Link
          to="/"
          className="flex items-center gap-2.5 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          <GlobeMark className="h-6 w-6 text-[#00529C] dark:text-white" />
          <span className="text-lg font-bold tracking-tight text-gray-900 dark:text-white">Globe Weekly</span>
        </Link>

        {currentUser ? (
          <UserMenu
            currentUser={currentUser}
            logout={logout}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
          />
        ) : (
          <IconButton
            icon={darkMode ? LuSun : LuMoon}
            label={darkMode ? 'Passer en thème clair' : 'Passer en thème sombre'}
            variant="outline"
            size="md"
            onClick={toggleDarkMode}
          />
        )}
      </div>
    </header>
  );
}

export default Topbar;
